// @flow
import React from 'react'
import { connect } from 'react-redux'
import format from 'date-fns/format'
import { User } from '../../types'
import Table from '../../components/Table'
import Tr from '../../components/Tr'
import Th from '../../components/Th'
import Td from '../../components/Td'

type Props = {
  user: User
}

const AdminUserAlerts = ({ user }: Props) => {
  const alerts = user.alerts || []

  return (
    <div>
      <Table>
        <thead>
          <Tr>
            <Th>Keyword</Th>
            <Th>Price</Th>
            <Th>Beds</Th>
            <Th>Baths</Th>
            <Th>Square feet</Th>
          </Tr>
        </thead>
        <tbody>
          {alerts.map((alert) => (
            <Tr key={alert.id}>
              <Td>{alert.keyword}</Td>
              <Td>
                ${Number(alert.minprice).toLocaleString()}&nbsp;- $
                {Number(alert.maxprice).toLocaleString()}
              </Td>
              <Td>{alert.minbeds} +</Td>
              <Td>{alert.minbaths} +</Td>
              <Td>{alert.minarea} +</Td>
            </Tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}

export default connect((state) => ({
  user: state.admin.user
}))(AdminUserAlerts)



// WEBPACK FOOTER //
// ./src/views/AdminUserAlerts/index.js